import isTablet from './isTablet';

const android = () =>
    /Android/i.test(navigator.userAgent) || (isTablet() && /Windows|Linux/i.test(navigator.userAgent));

const blackBerry = () => /BlackBerry/i.test(navigator.userAgent);

const iOS = () => /iPhone|iPad|iPod/i.test(navigator.userAgent) || (isTablet() && navigator.userAgent.includes('Mac'));

const opera = () => /Opera Mini/i.test(navigator.userAgent);

const windows = () => /IEMobile|WPDesktop/i.test(navigator.userAgent);

const any = () => android() || blackBerry() || iOS() || opera() || windows();

const isTVBrowser = () => {
    const ua = navigator.userAgent.toLowerCase();

    return /tizen|webos|smarttv|android.+tv|googletv|appletv|bravia|mibox|mitv/i.test(ua);
};

export default {
    android,
    blackBerry,
    iOS,
    opera,
    windows,
    any,
    isTVBrowser,
};
